export enum CrewRole {
    stagemanager = 'Stagemanager',
    showcaller = 'Showcaller',
    troubleshooter = 'troubleshooter',
    floortechnician = 'floortechnician',
    toneelmeester = 'toneelmeester'
}
